import { stringify } from 'query-string';
import { BASE_URL } from '../constants/api';
import { createGetAllAPI, createPatchAPI, createGetAPI } from '@cuemath/rest-api';

const { useGetAll: useCSMGetAll } = createGetAllAPI({
  getURL: (query = {}) => `${BASE_URL}/relationship-manager/?${stringify(query)}`,
});

const { useGetAll: useCSMParentsGetAll } = createGetAllAPI({
  getURL: ({ csmId, ...query }) =>
    `${BASE_URL}/relationship-manager/${csmId}/parents?${stringify(query)}`,
});

const { useGetAll: useCSMTeachersGetAll } = createGetAllAPI({
  getURL: ({ csmId, ...query }) =>
    `${BASE_URL}/relationship-manager/${csmId}/teachers?${stringify(query)}`,
});

const { useGet: useCSMGet } = createGetAPI({
  getURL: id => `${BASE_URL}/relationship-manager/${id}/`,
});

const { usePatch: useAssignCSMPatch } = createPatchAPI({
  getURL: userId => `${BASE_URL}/relationship-manager/${userId}`,
});

export {
  useCSMGetAll,
  useAssignCSMPatch,
  useCSMGet,
  useCSMParentsGetAll,
  useCSMTeachersGetAll,
};
